<div class="bg-dark" *ngIf="licenseInfoNeeded">
    <div class="container text-white">
        <div class="row d-flex py-4 justify-content-center justify-content-lg-around">
            <div *ngIf="hasItemsWithUpgradeProtection || hasItemsWithUpgradeProtectionOnly"
                 class="col-10 col-lg-3 p-2 ms-4 ms-lg-0">
                <div class="row align-items-center">
                    <div class="col-3">
                      <app-check-circle-fill-icon [size]="3"></app-check-circle-fill-icon>
                    </div>
                  <div class="col-9">
                    <p class="protection-text" *ngIf="!hasItemsWithoutUpgradeProtection; else mixedProtection"><strong>All
                      Items Include Maintenance</strong></p>
                    <ng-template #mixedProtection>
                      <p class="protection-text" *ngIf="hasItemsWithUpgradeProtection"><strong>Some Items Include
                        Maintenance</strong></p>
                    </ng-template>
                    <p class="protection-text" *ngIf="hasItemsWithUpgradeProtectionOnly"><strong>Items Are Maintenance
                      Only</strong></p>
                  </div>
                </div>
            </div>

            <div *ngIf="earliestEndDate" class="col-10 col-lg-3 p-2 ms-4 ms-lg-0">
                <div class="row align-items-center">
                    <div class="col-3">
                      <app-calendar-icon [size]="3"></app-calendar-icon>
                    </div>
                    <div class="col-9">
                        <p class="expiration-text">
                            <span *ngIf="hasNoUpgradeProtection; else maintenance">License</span>
                            <ng-template #maintenance>Maintenance</ng-template>
                            Expires<br>
                            <strong>{{earliestEndDate | date:'longDate'}}</strong>
                        </p>
                    </div>
                </div>
            </div>

            <div *ngIf="hasPerpetualLicense" class="col-10 col-lg-3 p-2 ms-4 ms-lg-0">
                <div class="row align-items-center">
                    <div class="col-3">
                      <app-calendar-icon [size]="3"></app-calendar-icon>
                    </div>
                    <div class="col-9">
                        <p class="perpetual-text">
                            Contract Term<br>
                            <strong>Perpetual License</strong>
                        </p>
                    </div>
                </div>
            </div>

        </div>
    </div>
</div>
